import {Component, Input} from '@angular/core';
import {AuthHeaderComponent} from "../auth-header/auth-header.component";
import {GuestHeaderComponent} from "../guest-header/guest-header.component";
import {NgClass, NgOptimizedImage} from "@angular/common";
import {ServicesDropdownComponent} from "../../../dropdowns/services-dropdown/services-dropdown.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router, RouterLink, RouterLinkActive} from "@angular/router";
import {SafePipe} from "../../../../../shared/pipes/safe.pipe";
import {SideBarComponent} from "../../../../../ui-lib/side-bar/side-bar.component";
import {StorageService} from "../../../../../core/services/storage.service";
import {SubdomainLoggedInHeaderComponent} from "../subdomain-logged-in/subdomain-logged-in-header.component";
import {MainStoreService} from "@cybfed/core/store/main.store.service";

@Component({
  selector: 'app-subdomain-streamer-header',
  standalone: true,
    imports: [
        AuthHeaderComponent,
        GuestHeaderComponent,
        NgOptimizedImage,
        ServicesDropdownComponent,
        TranslateModule,
        RouterLink,
        RouterLinkActive,
        SafePipe,
        SideBarComponent,
        NgClass,
        SubdomainLoggedInHeaderComponent
    ],
  providers: [
  ],
  templateUrl: './subdomain-streamer-header.component.html',
  styleUrl: './subdomain-streamer-header.component.scss'
})
export class SubdomainStreamerHeaderComponent {
    currentUser: any;
    selectedLanguage: any;
    shown: boolean = false;
    whiteLabel: any
    platformAdminRole: any

    currentUrl: string = '';
    constructor(private router: Router,
                private route: ActivatedRoute,
                private mainStoreService: MainStoreService,
                private translateService:TranslateService) {
        this.currentUser = StorageService.getJsonItem(StorageService.statics.currentUser);
        if(this.currentUser?.whiteLabels){
            let roleIndex = this.currentUser.whiteLabels.findIndex(l => l.whiteLabelId == this.currentUser.whiteLabelId);
            if(roleIndex >= 0){
                this.platformAdminRole = this.currentUser.whiteLabels[roleIndex].role
            }
        }
        this.selectedLanguage = StorageService.getItem(StorageService.statics.lang);
        if(!this.selectedLanguage) this.selectedLanguage = this.route.snapshot.paramMap.get('lang') || 'en';
        this.translateService.use(this.selectedLanguage);
        this.whiteLabel = this.mainStoreService.whiteLabel
    }

    ngOnInit() {
        // Subscribe to router events to get the current URL
        this.router.events.subscribe(()=>{
            this.currentUrl = this.router.url;
        })
    }
    isActive(url: string): boolean {
        return this.currentUrl === url;
    }

    selectLanguage(lang: string){
        this.translateService.use(lang);
        this.selectedLanguage = lang;
        StorageService.setItem(StorageService.statics.lang, lang);
    }


    toggleMenu(){
        this.shown = !this.shown;
    }

    closeMenu(){
        this.shown = false;
    }
}


